module.exports = __webpack_public_path__ + "img/张雪辉.34894828.jpg";